// Contract between the browser eval pipelines (ops-evals/pipeline/) and the dev-server
// model proxy (src/bin/opsEvalRunnerPlugin.ts). Kept free of Node imports so both sides
// can use it.

export const OPS_EVAL_MODEL_PATH = `/__ops-eval/model`

/** One structured-output model call, shaped like a production pipeline stage call. */
export type OpsEvalModelRequest = {
  model: string
  system: string
  user: string
  /** JSON Schema for the forced `extract` function's arguments. */
  parameters: Record<string, unknown>
}

export type OpsEvalUsage = { promptTokens: number; completionTokens: number }

/**
 * `args` is null when the model answered but gave no usable arguments after every
 * attempt; production treats that as a null result and falls back per stage. `error`
 * means the request itself failed (bad key, unknown model, network), which fails the run.
 */
export type OpsEvalModelResponse = { args: Record<string, unknown> | null; usage: OpsEvalUsage } | { error: string }
